
    const tab_nav = document.querySelectorAll('.tabs-nav');
    const acc_tab = document.querySelectorAll(".product-tabs-content");

    console.log('Tabs Nav:');
    console.log(tab_nav);
    console.log('Tabs Content:');
    console.log(acc_tab);

    tab_nav.forEach(element => {
        element.addEventListener('click', function () {
            let tabNav = element.dataset.contentId;
            let ans = document.getElementById(tabNav);
            acc_tab.forEach((ele) => {

                ele.classList.remove('active');
            })
            tab_nav.forEach((el) => {

                el.classList.remove('active_nav');
            })
            if (tabNav == ans.getAttribute('id')) {

                ans.classList.add('active');
                element.classList.add('active_nav');
            }
        })
    });